import React from 'react';
import s from './GridSettings.module.less';
import classNames from 'classnames';

interface Props {
  active?: boolean;
}

export const SettingIcon = ({ active, ...rest }: Props) => (
  <span {...rest} className={s.IconWrapper}>
    <span className={classNames(s.IconPart, active ? s.Active : s.NonActive)} />
    <span className={classNames(s.IconPart, active ? s.Active : s.NonActive)} />
    <span className={classNames(s.IconPart, active ? s.Active : s.NonActive)} />
  </span>
);
